import React, { Suspense, lazy, useEffect, useState } from "react";
import { motion } from "framer-motion";
import useMotionPreferences from "./useMotionPreferences";

const HomeHeroScene3D = lazy(() => import("./HomeHeroScene3D"));

function HeroFallbackNetwork() {
  return (
    <div className="public-home-premium__fallback-network" aria-hidden="true">
      <span className="public-home-premium__fallback-orbit public-home-premium__fallback-orbit--outer" />
      <span className="public-home-premium__fallback-orbit public-home-premium__fallback-orbit--mid" />
      <span className="public-home-premium__fallback-orbit public-home-premium__fallback-orbit--inner" />
      <span className="public-home-premium__fallback-node public-home-premium__fallback-node--one" />
      <span className="public-home-premium__fallback-node public-home-premium__fallback-node--two" />
      <span className="public-home-premium__fallback-node public-home-premium__fallback-node--three" />
      <span className="public-home-premium__fallback-node public-home-premium__fallback-node--four" />
      <span className="public-home-premium__fallback-connector public-home-premium__fallback-connector--one" />
      <span className="public-home-premium__fallback-connector public-home-premium__fallback-connector--two" />
    </div>
  );
}

export default function HomeHeroSystemVisual({ cards = [], stats = [], proofItems = [] }) {
  const { reducedMotion, isMobile } = useMotionPreferences();
  const [useCanvas, setUseCanvas] = useState(false);
  const visualProofItems = proofItems.filter(
    (item) => !["Verifikation vor Matching", "Readiness vor Ankunft", "Transparenz statt Vermittlungslogik"].includes(item),
  );

  useEffect(() => {
    if (reducedMotion || isMobile) {
      setUseCanvas(false);
      return undefined;
    }

    setUseCanvas(true);
    return undefined;
  }, [reducedMotion, isMobile]);

  return (
    <div className="public-home-premium__visual-stage">
      <div className="public-home-premium__visual-shell">
        <HeroFallbackNetwork />
        {useCanvas ? (
          <Suspense fallback={null}>
            <div className="public-home-premium__canvas-layer" aria-hidden="true">
              <HomeHeroScene3D />
            </div>
          </Suspense>
        ) : null}

        {visualProofItems.length ? (
          <div className="public-home-premium__visual-topbar" aria-hidden="true">
            <div className="public-home-premium__visual-topbar-track">
              {visualProofItems.map((item) => (
                <span key={item}>{item}</span>
              ))}
            </div>
          </div>
        ) : null}

        <div className="public-home-premium__visual-sensor-rail" aria-hidden="true">
          <span className="is-context" />
          <span className="is-flow" />
          <span className="is-decision" />
        </div>

        <div className="public-home-premium__stage-card-grid">
          {cards.map((card, index) => (
            <motion.article
              key={card.title}
              className="public-home-premium__stage-card"
              initial={false}
              whileHover={reducedMotion ? undefined : { y: -2 }}
              transition={{ duration: 0.55, delay: 0.15 + index * 0.08, ease: [0.22, 1, 0.36, 1] }}
            >
              <span>{card.label}</span>
              <strong>{card.title}</strong>
              <p>{card.detail}</p>
            </motion.article>
          ))}
        </div>

        <div className="public-home-premium__hero-stats-grid">
          {stats.map((item, index) => (
            <motion.article
              key={item.label}
              className="public-home-premium__hero-stat"
              initial={false}
              whileHover={reducedMotion ? undefined : { y: -2 }}
              transition={{ duration: 0.45, delay: 0.32 + index * 0.08 }}
            >
              <span>{item.label}</span>
              <strong>{item.value}</strong>
              <p>{item.caption}</p>
              <div className="public-home-premium__hero-stat-line" aria-hidden="true">
                <i style={{ width: `${68 + index * 8}%` }} />
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </div>
  );
}
